
import React, { createContext, useState, ReactNode, useCallback } from 'react';
import type { ToastProps } from '@/hooks/use-toast';

interface ToastContextType {
  toasts: ToastProps[];
  addToast: (toast: ToastProps) => string | null;
  removeToast: (id?: string) => void;
}

// Create a default context implementation
const defaultContext: ToastContextType = {
  toasts: [],
  addToast: () => null,
  removeToast: () => {}
};

// Create context with the default implementation
export const ToastContext = createContext<ToastContextType>(defaultContext);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastProps[]>([]);
  
  console.log("ToastProvider rendering");

  const addToast = useCallback((toast: ToastProps): string | null => {
    if (!toast) return null;
    
    const id = toast.id || Math.random().toString(36).substring(2, 9);
    const newToast = { ...toast, id };
    
    console.log("Adding toast:", id);
    setToasts(prev => [...prev, newToast]);
    
    // Auto-dismiss toast after 5 seconds
    setTimeout(() => {
      removeToast(id);
    }, 5000);
    
    return id;
  }, []);

  const removeToast = useCallback((id?: string) => {
    console.log("Removing toast:", id || "all");
    setToasts(prev => 
      id 
        ? prev.filter(toast => toast.id !== id)
        : []
    );
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
};
